import Reveal from "@/components/feature/Reveal";
import { replyList } from "@/mocks/homeContent";

export default function ReplySection() {
  return (
    <section id="reply" className="bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                当事人回应，原话都在这
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                只看转述容易走样，我们把回应的原话和时间点单独拎出来，按先后顺序排好。
              </p>
            </div>
            <span className="inline-flex shrink-0 items-center gap-2 self-start rounded-full border border-accent-200 bg-accent-50 px-3.5 py-1.5 text-xs text-accent-800 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-chat-quote-line text-base" />
              </span>
              已收录 4 条回应
            </span>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {replyList.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <article className="relative flex h-full flex-col rounded-lg border border-background-200 bg-background-100/50 p-5 md:p-6">
                <span className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center text-accent-300">
                  <i className="ri-double-quotes-r text-2xl" />
                </span>
                <div className="flex items-center gap-2.5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-900 text-xs font-medium text-background-50">
                    {item.who.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{item.who}</p>
                    <p className="text-xs text-foreground-500">{item.time} 发布</p>
                  </div>
                </div>

                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800 md:text-[15px]">
                  「{item.quote}」
                </p>

                <span
                  className={
                    item.status === "已回应"
                      ? "mt-4 inline-flex w-fit items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
                      : "mt-4 inline-flex w-fit items-center gap-1.5 rounded-full bg-background-200 px-2.5 py-1 text-xs text-foreground-600"
                  }
                >
                  <i className={item.status === "已回应" ? "ri-check-line text-sm" : "ri-time-line text-sm"} />
                  {item.status}
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}